import React from "react";
import { injectIntl } from "react-intl";
import { Grid, Typography } from "@material-ui/core";

const Member2FAState = ({ member, intl }) => (
  <Grid container>
    <Grid item>
      <Typography
        data-testid="member-2fa-state"
        variant="body2"
        style={{ textTransform: "uppercase", fontWeight: "400" }}
      >
        {intl.formatMessage({
          id:
            member && member.isMFAEnabled
              ? "app.general.on"
              : "app.general.off",
        })}
      </Typography>
    </Grid>
  </Grid>
);

export default injectIntl(Member2FAState);
